<template>
  <div class="page">
    <van-nav-bar title="实习总结" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="empty" v-if="showEmpty">
      <img src="../../../../assets/images/sx_empty.png" alt="" />
      <div>暂无实习总结</div>
      <div class="button" @click="$router.push({ path: `/internship/summary` })">
        新增总结
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else style="padding-bottom: 100px">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="item-box" v-for="(item, index) in list" :key="index" @click="$router.push({ path: `/internship/summaryDetail?sxzjid=${item.sxzjid}` })">
          <div class="title-line">
            <div class="title">{{ item.xm }}提交的总结</div>
            <div class="date">{{ item.tjsj }}</div>
          </div>
          <div class="date">班级: {{item.bj}}</div>
          <div class="date">标题: {{item.bt}}</div>
          <div class="tip-box">
            <div class="status" :style="{ borderColor: getStatusColor(item.zt), color: getStatusColor(item.zt) }">{{item.zt}}</div>
            <!-- <p>提醒审批</p> -->
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="button-box" v-if="list.length > 0">
      <van-button @click="$router.push({ path: `/internship/summary` })">新增总结</van-button>
    </div>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
export default {
  components: {
    
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      showEmpty: false,
    }
  },
  computed: {
    // 审核状态：0-未通过，1-通过，2-审核中，3-待送审，4-终止流程
    getStatusColor() {
      return status => {
        let color = ['#FFA400', '#41B29C']
        if(status == '待评阅'){
          return color[0]
        }
        return [1]
      }
    }
  },
  methods: {
    async onLoad() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const res = await iApi.getSummaryList({
        page: this.page,
        size: this.pageSize,
      })
      this.list = this.list.concat(res.data)
      this.list.splice(0, 0)
      this.loading = false
      if (res.data.length < this.pageSize) {
        this.finished = true
      } else {
        this.page += 1
      }
      if ((this, this.list.length == 0)) {
        this.showEmpty = true
      }
    },
    onRefresh() {
      console.log('下拉刷新')
      // 清空列表数据
      this.list = []
      this.page = 1
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
  },
  created() {
    // this.onLoad()
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  position: relative;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
  .button {
    width: 232px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
  }
}
.item-box {
  width: 315px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }
  .tip-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    p {
      color: #0088f8;
    }
  }
}
.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .van-button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px !important;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/summaryList.vue